"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundUp = exports.replaceFirstDotToEmpty = exports.replaceZeroToEmpty = exports.onlyNumberAndADot = exports.checkIsNaturalNumberWithZero = exports.checkIsNaturalNumber = exports.numberPrecision = exports.revertCommaNumber = exports.parseNumberToComma = exports.numberToDecimalString = exports.parseNumberToDecimal = void 0;
var parseNumberToDecimal = function (value, decimals) {
    if (decimals === void 0) { decimals = 0; }
    if (!value) {
        return '';
    }
    return value
        .split('-')
        .map(function (p) {
        return exports.numberToDecimalString(parseFloat(p.trim()), decimals);
    })
        .join(' - ');
};
exports.parseNumberToDecimal = parseNumberToDecimal;
var numberToDecimalString = function (value, decimals) {
    if (decimals === void 0) { decimals = 0; }
    return value.toFixed(decimals).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};
exports.numberToDecimalString = numberToDecimalString;
var parseNumberToComma = function (value) {
    return value.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};
exports.parseNumberToComma = parseNumberToComma;
var revertCommaNumber = function (value) {
    return value.replace(/,/g, '');
};
exports.revertCommaNumber = revertCommaNumber;
var numberPrecision = function (num, decimals) {
    if (decimals === void 0) { decimals = 0; }
    return num.toFixed(decimals);
};
exports.numberPrecision = numberPrecision;
var checkIsNaturalNumber = function (arg) {
    return /^(|[1-9]\d*)$/.test(arg);
};
exports.checkIsNaturalNumber = checkIsNaturalNumber;
var checkIsNaturalNumberWithZero = function (arg) {
    return /^(|[0-9]\d*)$/.test(arg);
};
exports.checkIsNaturalNumberWithZero = checkIsNaturalNumberWithZero;
var onlyNumberAndADot = function (arg) {
    return /^[0-9]*\.?[0-9]*$/.test(arg);
};
exports.onlyNumberAndADot = onlyNumberAndADot;
var replaceZeroToEmpty = function (arg) {
    return arg.replace(/^0+/, '');
};
exports.replaceZeroToEmpty = replaceZeroToEmpty;
var replaceFirstDotToEmpty = function (arg) {
    return arg.replace(/\./g, '');
};
exports.replaceFirstDotToEmpty = replaceFirstDotToEmpty;
var roundUp = function (value, precision) {
    return Math.ceil(Number(exports.revertCommaNumber(value)) / precision) * precision;
};
exports.roundUp = roundUp;
